export default "__VITE_ASSET__bf91a758__"